// src/pages/ClientData/components/BulkLoadDialog.js
import React from 'react';

// Diálogo de progresso do carregamento em massa de movimentos/ficheiros.
// Fica visível enquanto a API do Duralex é percorrida, mostrando os totais
// acumulados em cada etapa do loop de paginação para o utilizador saber que
// o processamento não parou.
const BulkLoadDialog = ({ progress, onClose }) => {
  if (!progress) return null;

  const {
    phase,
    withFiles,
    processesTotal,
    processesDone,
    currentProcess,
    currentPage,
    lastPage,
    movementsLoaded,
    filesLoaded,
    error
  } = progress;

  const concluido = phase === 'concluido';
  const erro = phase === 'erro';
  const emProgresso = !concluido && !erro;

  const faseTexto = () => {
    if (erro) return '❌ Ocorreu um erro';
    if (concluido) return '✅ Carregamento concluído';
    if (phase === 'ficheiros') return '📎 A carregar ficheiros dos movimentos...';
    return '📋 A carregar movimentos dos processos...';
  };

  return (
    <div className="cd-bulk-overlay">
      <div className="cd-bulk-dialog" role="dialog" aria-modal="true">
        <div className="cd-bulk-header">
          {emProgresso && <span className="cd-bulk-spinner" aria-hidden="true">⏳</span>}
          <h3>{faseTexto()}</h3>
        </div>

        {currentProcess && emProgresso && (
          <p className="cd-bulk-current">
            Processo <strong>{currentProcess}</strong>
            {lastPage > 0 && phase === 'movimentos' && (
              <span> — página {currentPage}/{lastPage}</span>
            )}
          </p>
        )}

        <div className="cd-bulk-stats">
          <div className="cd-bulk-stat">
            <span className="cd-bulk-stat-value">{processesDone}/{processesTotal}</span>
            <span className="cd-bulk-stat-label">Processos</span>
          </div>
          <div className="cd-bulk-stat">
            <span className="cd-bulk-stat-value">{movementsLoaded}</span>
            <span className="cd-bulk-stat-label">Movimentos</span>
          </div>
          {withFiles && (
            <div className="cd-bulk-stat">
              <span className="cd-bulk-stat-value">{filesLoaded}</span>
              <span className="cd-bulk-stat-label">Ficheiros</span>
            </div>
          )}
        </div>

        {erro && <div className="error-message">{error}</div>}

        {(concluido || erro) && (
          <div className="cd-bulk-actions">
            <button type="button" className="action-btn chat-btn" onClick={onClose}>
              Fechar
            </button>
          </div>
        )}

        {emProgresso && (
          <p className="cd-bulk-hint">
            Este processamento pode demorar. Não feche a página até concluir.
          </p>
        )}
      </div>
    </div>
  );
};

export default BulkLoadDialog;
